import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

export default function useFreeAccountStatus(enabled = true) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setFailed(false);

    axios.get(`${API_BASE_URL}/free-accounts-status`)
      .then(({ data }) => {
        if (!cancelled && data?.success) setStatus(data);
      })
      .catch(() => {
        if (!cancelled) {
          setStatus(null);
          setFailed(true);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return {
    status,
    loading,
    failed,
    hasFreeLeft: !!status && status.remaining > 0,
  };
}
